'use client';

import { useEffect, useState } from 'react';

const ADS = [
  { src: '/credentially_cover.jpeg', alt: 'Credentially' },
  { src: '/salvehealth_cover.jpeg', alt: 'Salve Health' },
  { src: '/naqcyber_cover.jpeg', alt: 'Naq Cyber' },
];

const INTERVAL_MS = 4000;

export default function AdBanner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % ADS.length);
    }, INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  const ad = ADS[index];

  return (
    <div className="fixed bottom-6 left-1/2 z-30 -translate-x-1/2">
      <div className="relative w-[600px] max-w-[90vw] overflow-hidden rounded-xl shadow-lg">
        <img
          key={ad.src}
          src={ad.src}
          alt={ad.alt}
          className="w-full h-auto object-cover animate-[fadeIn_0.5s_ease-in-out]"
        />
        <span className="absolute bottom-2 right-3 rounded bg-black/40 px-1.5 py-0.5 text-[9px] text-white/70">
          Ad
        </span>
      </div>
      {/* Dots */}
      <div className="flex justify-center gap-1.5 pt-2">
        {ADS.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`h-1.5 rounded-full transition-all ${
              i === index ? 'w-4 bg-white' : 'w-1.5 bg-white/50'
            }`}
          />
        ))}
      </div>
    </div>
  );
}
